// extracted by mini-css-extract-plugin
export default {"icon":"customerJourneyVisualizationIcon_icon__7se+F"};